import React from 'react';
import {useSelector} from "react-redux";
import {airtable_config_get_label} from "../redux/actions";

export const PageInfo = () => {
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const userEmail = useSelector(state => state.app.userEmail)
    const title = configData !== null ? airtable_config_get_label(configData, 'page_info_title', locale) : null;
    const description = configData !== null ? airtable_config_get_label(configData, 'page_info_description', locale).replace('%%', '<strong>' + userEmail + '</strong>') : null;
    return (
        <section className="pageInfo container">
            <div className="container__wrap">
                <h1 className="pageInfo__title">{title}</h1>
                <p className="pageInfo__description" dangerouslySetInnerHTML={{__html:description}}/>
            </div>
        </section>
    )
}